import { assert } from '../../lib/assert-sidecar'
import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 3
  d.useSystemTimer += ds
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime
    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let bodies: IVoyageCrew[] = l.filter(voyageCrew.getAll(), (c) => {
      if (
        !(c.type === EVoyageCrewType.Crew || c.type === EVoyageCrewType.Alien)
      ) {
        return false
      }
      if (!c.isDying) {
        return
      }
      return true
    }) as IVoyageCrew[]

    if (bodies.length > 0) {
      let cr = rando.sample(bodies)

      let fire = voyageCrew.create(EVoyageCrewType.Fire, -1)
      voyageCrew.moveToIJ(fire, cr)

      voyageCrew.kill(cr)
      voyageSounds.playExplosionFire()
    }
  }
}
